import Link from 'next/link';
import { Tooltip } from '../Tooltips';
import { getBreadCrumbElementClass } from './helper';
import { BreadcrumbItemProps } from './types';

const BreadcrumbItem = (props: BreadcrumbItemProps) => {
  const { path, name, isLastItem, className } = props;

  const finalClassName = getBreadCrumbElementClass(
    'px-1 ' + className,
    isLastItem
  );

  return (
    <Tooltip title={name} placement="bottom">
      <Link href={path} className="flex items-center">
        <a className={finalClassName}>{name}</a>
      </Link>
    </Tooltip>
  );
};

export default BreadcrumbItem;
